import React, { useCallback, useState, createContext, useContext } from 'react';
type ApplyContextValue = {
  isOpen: boolean;
  open: () => void;
  close: () => void;
};
const ApplyContext = createContext<ApplyContextValue | null>(null);
export const ApplyProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return <ApplyContext.Provider value={{
    isOpen,
    open,
    close
  }} data-id="element-19">
      {children}
    </ApplyContext.Provider>;
};
export const useApply = () => {
  const ctx = useContext(ApplyContext);
  if (!ctx) throw new Error('useApply must be used within ApplyProvider');
  return ctx;
};